import { Button } from 'antd'
import React from 'react'
import styles from './ModalButtons.module.scss'
import { useComponentLocale } from '../../../../../../hooks/useComponentLocale'

function ModalButtons({ text, onPastePresetData, onClearText, onTryPreset }) {
	const getLocale = useComponentLocale()
	const tryPresetLocale = getLocale({ component: 'theme', section: 'try_preset' })
	const clearBtnLocale = getLocale({ component: 'common_buttons', section: 'clear' })
	const pasteBtnLocale = getLocale({ component: 'common_buttons', section: 'paste' })

	return (
		<div className={styles.buttonsContainer}>
			<div>
				<Button key='Clear' onClick={onClearText}>
					{clearBtnLocale}
				</Button>

				<Button key='Paste' onClick={(e) => onPastePresetData(e)}>
					{pasteBtnLocale}
				</Button>
			</div>

			<div>
				<Button key='Try preset' onClick={onTryPreset} disabled={text === ''}>
					{tryPresetLocale}
				</Button>
			</div>
		</div>
	)
}

export default ModalButtons
